<template>
  <div id="app" class="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import Left from './components/Left.vue'
import Right from './components/Right.vue'
import Login from '../src/views/Login/login.vue'
export default {
  name: 'App',
  components: { Left, Right, Login },
  provide() {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入。
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true //控制router-view是否显示达到刷新的效果
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
}
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  position: relative;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  width: 100%;
  height: 100%;
}
.left {
  height: 100%;
  background: #040848;
}
.right {
  height: 100%;
  background: #fff;
}
</style>
